// generated by genversion
export var version = '4.0.2';
//# sourceMappingURL=version.js.map